/**
 * @fileoverview Step Styles
 * @version 1.0
 * @author Carlos Emilio Blanco Lopez
 * @date 14/02/2023
 * @copyright 2023 Industrias RESSER S.A de C.V
 */

import { makeStyles } from "@mui/styles";
import { Fonts, Colors } from "../utils/constants";
import { hover } from "@testing-library/user-event/dist/hover";

const styles = makeStyles((theme?: any) => ({
    stepperContainer: {
        width: "70%",
        height: 100,
        marginTop: 30,
        marginBottom: 30,
    },
    quoteTypeTitle: {
        fontFamily: Fonts.sspBold,
        fontSize: 34,
        color: "white",
        textAlign: "center",
    },
    toggleButton: {
        [theme.breakpoints.up('sm')]: {
            width: 185,
        },
        [theme.breakpoints.down('sm')]: {
            width: 140,
        },
    },
    // Style FirstStep
    firstStepContainer: {
        height: "auto",
        padding: 30,
        width: "90%",
        paddingBottom:0,
        
        [theme.breakpoints.down('sm')]: {
            flexDirection: "column",
            width: "100%",
            marginTop:"-80px",
        },
    },
    selectActiveTxt: {
        alignContent:"center",
        fontFamily: Fonts.sspBold,
        fontSize: 34,
        color: "white",
        margin: 0,
        marginTop: 25,
        [theme.breakpoints.down('sm')]: {
            fontSize: "1.5em",
            width: "100%",
        },
    },
    resumeFieldsTxt: {
        color: 'white',
        fontSize: 12,
        fontFamily: Fonts.sspLight,
        marginBottom: 15,
        lineHeight: 1.2,
        [theme.breakpoints.down('sm')]: {
            fontSize: "16px",
            width: "100%", 
             alignItems: "stretch"       
        },
    },
    warningFieldsTxt:{
        color: 'white',
        fontSize: 10,
        fontFamily: Fonts.sspLight,
        lineHeight: 1.2,
    },
    resumeValueTxt: {
        fontSize: 16,
        fontFamily: Fonts.sspBold,
        color: Colors.yellow,
        marginBottom: 0,
        [theme.breakpoints.down('lg')]: {
            fontSize: "25px"
        },
    },
    subtitleTxt: {
        fontFamily: Fonts.sspBold,
        fontSize: 20,
        color: "white",
        margin: 0,
        [theme.breakpoints.down('sm')]: {
            fontSize: "1,2em",
        },
    },
    checkboxGroup: {
        display: 'flex',
        justifyContent: 'space-evenly',
        marginTop: 20,
        [theme.breakpoints.down('sm')]: {
            flexDirection: "column",
            height: 150
        },
    },
    checkboxIn: {
        fontSize: 12,
        fontFamily: Fonts.sspMedium,
        display: "flex",
        alignItems: "center",
        color: Colors.yellow
    },
    checkboxOut: {
        fontSize: 12,
        fontFamily: Fonts.sspMedium,
        display: "flex",
        alignItems: "center",
    },
    cardFormOption: {
        backgroundColor: Colors.yellow
    },
    // Style SecondStep
    FormularioContainer: {
        height: "100vh",
        width: "90%",
        display: "flex",
        flexDirection: "column",
        justifyContent: 'center',
        alignItems: 'center',
        padding: 30,
    },
    ContainerEkatena: {
        width: "100%",
        height: "max-content",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        borderRadius: 10,
        boxShadow: `0px 0px 15px #000`,
        backgroundColor: '#F9F9F9',
        marginLeft: 15,
        marginBottom: 50,
        marginTop: 20,
        [theme.breakpoints.up('md')]: {
            width: 350,
        },
        [theme.breakpoints.down('sm')]: {
            width: "fit-content"
        }
    },
    textInputEkatena: {
        width: '100%',
        backgroundColor: '#D7D8DA',
        fontFamily: Fonts.sspRegular,
    },
    ContentViewEkatena: {
        marginBottom: 30,
        marginTop: 40,
    },
    nexBttn: {
        width: 206,
        height: 56,
        fontFamily: Fonts.sspBold,
        fontSize: 16,
        backgroundColor: Colors.yellow,
        color: Colors.blue,
        borderWidth: 0,
    },
    continueBttn: {
        width: 206,
        height: 56,
        fontFamily: Fonts.sspRegular,
        fontSize: 18,
        backgroundColor: Colors.yellow,
        color: Colors.blue,
        borderWidth: 0,
    },
    checkBoxEkatena: {
        marginTop: 30,
        marginBottom: 15,
    },
    labelTerminosEkatena: {
        width: '85%',
        textAlign: 'left',
        fontSize: 11,
        margin: 0,
    },

    SixView: {
        height: "100%",
        padding: 30,
        width: "90%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    sixthStepAuth: {
        marginTop: 30,
        display: "flex",
        justifyContent: "space-around",
        width: "40vw",
        [theme.breakpoints.down('sm')]: {
            flexDirection: "column"
        },
    },
    sixthStepAuthCheckBox: {
        display: "flex",
        alignItems: "center",
        marginBottom: 30,
        marginRight: 10,
        [theme.breakpoints.down('sm')]: {
            marginBottom: 25
        },
    }

}));

export default styles;